import type { FaireProductEntity } from "../../entity_types/product";

export const p_j6as2zau55: FaireProductEntity = {
  token: "p_j6as2zau55",
  type: "product",
  name: "Okloveyoubye Chunky Notepad",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/677283cc4298a3a9720058a0740ed1ce370984d6674dc4ea0d38bde81510fb42.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c966a8d32c1f90ef0d67299b4c59ea36b8f68498a65e416903ef806e6e32b125.png",
    "https://cdn.faire.com/fastly/b3d69474e80a16664a73f39e7f0b295ac3e3c333da1f348f8a8d7b64a7fa3e64.png",
    "https://cdn.faire.com/fastly/08fc1d62962290996502ff5609da234cb23c7a4344cbf5676b6ce87d705f8115.png",
    "https://cdn.faire.com/fastly/83ee41f3b2d445956549af41a75a0f598d6acdf5021c204ba544ba177cebfd97.png",
  ],
  priceDollars: 9,
  description:
    "Big and chunky. It's how we like our desserts and this awesome square notepad. This is the guy you pull out when you need an extra sturdy surface for those big, chunky ideas.",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:06.296Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
